import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { botTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const editBotAllowedUser: botTypes.EditAllowedUser = async (data) => {
  const { _id, ...dataWithoutId } = data;
  return axios.patch(`/bot/allowed-users/${_id}`, { data: dataWithoutId });
};

type EditBotAllowedUserOptions = {
  config?: MutationConfig<typeof editBotAllowedUser>;
};

export function useEditBotAllowedUser({ config = {} }: EditBotAllowedUserOptions) {
  return useMutation({
    ...config,
    onMutate: (...args) => {
      toasts.loadingToast.loading('edit-bot-allowed-user', 'Editing user...');
      config.onMutate?.(...args);
    },
    onSuccess: (...args) => {
      queryClient.invalidateQueries(['bot-allowed-users']);
      toasts.loadingToast.success('edit-bot-allowed-user', 'User name edited successfully');
      config.onSuccess?.(...args);
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error('edit-bot-allowed-user', serverMessage);
      config.onError?.(error, ...args);
    },
    mutationFn: (data) => editBotAllowedUser(data),
  });
}
